// ═══ 검차 셸 API 래퍼 (신고 371) — 서버 변경 0, 기존 /api/eval/orders 계약 그대로 ═══
// 반드시 utils/api.js 의 API + authFetch 를 경유한다 (상대경로 fetch 금지 — 서버 소스 가드).
// 성공: 서버 응답 body 를 그대로 반환({success, data, ...}).
// 실패: Error(message) + { status, code } 로 정규화 → parts/ErrorText + errors.describeSimpleError 가 소비.
import { API, authFetch } from '../../utils/api';

function apiError(status, code, message) {
  var e = new Error(message || code || ('HTTP ' + status));
  e.status = status;
  e.code = code || '';
  return e;
}

function request(path, options) {
  return authFetch(API + '/eval/orders' + path, options).then(function (res) {
    return res.json().catch(function () { return {}; }).then(function (body) {
      if (!res.ok || (body && body.success === false)) {
        throw apiError(res.status, body && body.code, body && (body.error || body.message));
      }
      return body || {};
    });
  });
}

function jsonPost(path, payload) {
  return request(path, { method: 'POST', body: JSON.stringify(payload || {}) });
}

function query(params) {
  var q = [];
  Object.keys(params || {}).forEach(function (k) {
    var v = params[k];
    if (v === undefined || v === null || v === '') return;
    q.push(encodeURIComponent(k) + '=' + encodeURIComponent(v));
  });
  return q.length ? '?' + q.join('&') : '';
}

/// 목록 — { success, data[], counts{status} }. params: {status, search, date_from, date_to}
export function listOrders(params) { return request('/' + query(params)); }

/// 상세 — { success, data } (eval_result 미제출 시 _pending)
export function getOrder(id) { return request('/' + encodeURIComponent(id)); }

/// 신청 (multipart FormData — photos[] 최대 3장, 20MB/장). Content-Type 은 authFetch 가 건드리지 않는다.
export function createOrder(formData) { return request('/', { method: 'POST', body: formData }); }

/// 헤이딜러 캡처 OCR — 필드 프리필용(실패 허용). 최대 3장을 한 번의 모델 호출로 합쳐 읽는다.
/// 서버(routes/eval-orders.js)는 `files` 우선 · 레거시 단일 `file` 폴백 — 앱 eval_service.ocrHeydealer
/// 와 같은 계약으로 둘 다 보낸다(구 서버 역호환). 인자는 File 1개 또는 File 배열.
export function ocrHeydealer(files) {
  var list = Array.isArray(files) ? files : [files];
  var fd = new FormData();
  list.forEach(function (f) { fd.append('files', f); });
  fd.append('file', list[0]);
  return request('/ocr-heydealer', { method: 'POST', body: fd });
}

/// 기본 검차비 — { success, data: { baseFee } }
export function feeDefault() { return request('/fee-default'); }

/// 매입 결정 — purchase_price(원)는 **클라가 >0 강제**(서버 미검증).
export function decideOrder(id, payload) { return jsonPost('/' + encodeURIComponent(id) + '/decide', payload); }

/// 매입 안 함 — reason 은 항상 한국어 고정 4종(평가사·관리자가 읽는 값).
export function rejectOrder(id, reason) { return jsonPost('/' + encodeURIComponent(id) + '/reject', { reason: reason || '' }); }

/// 신청 취소 — open/taken/inspecting 만. 400 EVAL_COMPLETED. payload: {reason_code, reason_note}
export function cancelOrder(id, payload) { return jsonPost('/' + encodeURIComponent(id) + '/cancel', payload || {}); }

/// 화면 언어를 서버 users.locale 에 저장(검차 신청 취소 사유 통지 BUILD_PLAN §2.4) — 실패는 조용히 무시.
export function putLocale(locale) {
  return authFetch(API + '/auth/locale', {
    method: 'PUT', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ locale: locale }),
  }).then(function () {}, function () {});
}

/// 결과 메모 AI 번역 — { success, translated }. 503 TRANSLATION_UNAVAILABLE(번역 불가) / 502 TRANSLATION_FAILED.
/// params: { lang, field } — field 는 eval_results 컬럼명(inspector_notes/wheel_notes/tire_notes/body_notes).
export function notesTranslation(id, params) {
  return request('/' + encodeURIComponent(id) + '/notes-translation' + query(params));
}

/// 리포트 공유 링크 — { success, url, expiresAt } (90일, 다회용). 1회용 링크는 공유 금지.
export function reportLink(id) { return request('/' + encodeURIComponent(id) + '/report-link'); }

/// 검차정산 — { success, count, total, items[], by_inspector[] }. params: {month:'YYYY-MM', inspector_id}
export function companySettlement(params) { return request('/company-settlement' + query(params)); }
